import Loader from 'common/components/loaders/Loader'
import { useAppSelector } from 'common/hooks/redux'
import { useVariantInsights } from 'features/unifiedFlow/contentPage/generate/context/VariantInsightsContext'

import Insights from './Insights'
import { ActivePanel, HandleActivePanelChange } from './RightSection'
import VariantInspector from './VariantInspector'

type Props = {
  activePanel: ActivePanel | undefined
  isOptimized?: boolean
  handleActivePanelChange: HandleActivePanelChange
}

const InsightsVariantManager = ({
  activePanel,
  isOptimized,
  handleActivePanelChange,
}: Props) => {
  const {
    rightPanelRef,
    state: { isVariantSelected },
  } = useVariantInsights()

  const {
    isLoading,
    isWaitingState: { isWaiting },
  } = useAppSelector((state) => state.campaignStates)

  const getState = () => {
    if (isVariantSelected) {
      return 'variantInspector'
    } else {
      return 'insights'
    }
  }

  const state = getState()

  return (
    <div ref={rightPanelRef} className="h-full">
      {
        {
          variantInspector:
            isOptimized && (isLoading || isWaiting) ? (
              <div className="flex flex-col h-100 lg:h-full">
                <Loader />
              </div>
            ) : (
              <VariantInspector
                activePanel={activePanel}
                handleActivePanelChange={handleActivePanelChange}
              />
            ),
          insights: (
            <Insights
              activePanel={activePanel}
              handleActivePanelChange={handleActivePanelChange}
            />
          ),
        }[state]
      }
    </div>
  )
}

export default InsightsVariantManager
